import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import React, { useCallback, useEffect, useState } from "react";
import { BrowserRouter as Router, useRoutes, Link, useNavigate, useSearchParams, } from "react-router-dom";
import { Button, ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import logo from './assets/images/Logo.png'; // Importez le chemin de votre image
import Auth from './Auth';
import CotisationGere from './CotisationGere';
import CotisationChoix from './CotisationChoix';
import Adhere from './Adhere';
import PrelevementSepaForm from './PrelevementSepaForm';
import Export from './Export';
import AdhesionByType from './AdhesionByType';
import { cleanJson } from './utils/Columns';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import AdhesionManuelle from './AdhesionManuelle';
import Mail from './Mail';
import Adh from './Adh';
import Relance from './Relance';
import moment from 'moment';
import ManageDropdown from './ManageDropdown';
import GenerePdfManuel from './GenerePdfManuel';
import Prelevement from './Prelevement';
import TribuRappro from './TribuRappro';
import Tribu from './Tribu';


const App = ({ setIsAdmin, setAuthentOk, anneeSel, setAnneeSel, smallurl, url }) => {

    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();

    // const [adherentsLight, setAdherentsLight] = useState([]);
    const [code, setCode] = useState(localStorage.getItem('code') || '');
    const [anneeencours, setAnneeencours] = useState('');

    const getCotisation = () => {
        fetch(`${url}GetCotisations/`)
            .then(response => response.json())
            .then(data => {
                localStorage.setItem('cotisations', JSON.stringify(cleanJson(data.data)));
            })
            .catch(error => console.error('Erreur:', error));
    }

    const gotoAuth = useCallback(() => {
        setAuthentOk(false);
        setCode('');
        localStorage.removeItem('code');
        navigate('/auth');
    }, [navigate, setAuthentOk, setCode]);

    useEffect(() => {
        // Définir l'intervalle pour vérifier l'authentification toutes les 60000 ms (1 minute)
        const intervalId = setInterval(() => {
            // Si l'utilisateur se trouve sur une page d'authentification, on ne fait rien.
            if (window.location.href.includes('auth')) {
                return;
            }

            const lcode = localStorage.getItem('code');
            if (!lcode) {
                console.error("Aucun code trouvé dans le localStorage.");
                return;
            }

            fetch(`${url}CheckAuth/${lcode}`)
                .then(response => response.json())
                .then(data => {
                    console.log('Réponse du serveur:', data);
                    if (data === false) {
                        gotoAuth();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }, 60000);

        // Nettoyer l'intervalle lors du démontage du composant
        return () => clearInterval(intervalId);
    }, [url, gotoAuth]);

    useEffect(() => {
        console.log('useeffect reloadData', anneeSel)
        if (anneeencours !== '' && anneeSel !== anneeencours) {
            localStorage.setItem('annee', anneeSel);
            reloadData(anneeSel);
            setAnneeencours(anneeSel);
        } else if (anneeSel === '2000') {
            setAnneeencours(anneeSel);
        }
    }, [anneeSel]);

    const getDropdown = () => {
        return fetch(`${url}GetDropdown`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Réponse du serveur:', data);
                localStorage.setItem('dropdown', JSON.stringify(cleanJson(data.data)));
            })
            .catch(error => console.error('Erreur:', error));
    }

    const [tribus, setTribus] = useState([]);

    const getTribus = () => {
        return fetch(`${url}GetTribus`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Réponse du serveur:', data);
                setTribus(cleanJson(data.tribus));
                localStorage.setItem('tribus', JSON.stringify(cleanJson(data.tribus)));
            })
            .catch(error => console.error('Erreur:', error));
    }


    const getAnnee = () => {
        return fetch(`${url}getAnnee`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Réponse du serveur:', data);

                let annee = parseInt(data.data);
                setAnneeencours(annee);
                setAnneeSel(annee);
                localStorage.setItem('annee', annee);
                return annee;
            })
            .catch(error => console.error('Erreur:', error));
    }

    useEffect(() => {
        localStorage.setItem('url', url);
        localStorage.setItem('smallurl', smallurl);

        console.log('codeadh:', searchParams.get("codeadh"));
        if (searchParams.get("codeadh") && searchParams.get("mail")) {
            console.log('navigateToAdhere');
            getDropdown().then(() => navigate(`/adhere/${searchParams.get("codeadh")}/${searchParams.get("mail")}/${searchParams.get("success")}`));
            // navigate(`/adhere/${searchParams.get("codeadh")}/${searchParams.get("mail")}/${searchParams.get("success")}`);
        } else {
            setIsAdmin(true);
            if (code === '') {
                gotoAuth();
                return;
            } else {
                getAnnee().then((e) => {
                    console.log('getAnnee', e);
                    reloadData(e);
                    getDropdown();
                    getCotisation();
                    getTribus();
                });
            }
        }
    }, []);

    useEffect(() => {
        if (!(searchParams.get("codeadh") && searchParams.get("mail"))) {
            reloadData();
        }
    }, [code]);

    const GetAllDataRelevant = () => {
        getDropdown();
        getCotisation();
        getTribus();
    }

    const authOK = (code) => {
        console.log(code)
        setAuthentOk(true);
        setCode(code);
        if (code !== undefined) {
            GetAllDataRelevant();
        }
        navigate('/');
    }



    const reloadData = (annee) => {
        // console.log('reloadData');
        if (code === '') {
            gotoAuth();
            return;
        }
        if (!annee)
            annee = anneeSel;

        // Appel de l'API
        // fetch(`${url}GetAdherentsLight/${annee}/${code}`)
        //     .then(response => response.json())
        //     .then(data => {
        //         // Traiter la réponse si nécessaire
        //         console.log('Réponse du serveur:', data);
        //         if (data === '0' || !data.data)
        //             gotoAuth();
        //         else {
        //             setAdherentsLight(cleanJson(data.data));
        //         }
        //     })
        //     .catch(error => console.error('Erreur:', error));
    }

    let routes = useRoutes([
        { path: "/auth", element: <Auth authOK={authOK} /> },
        { path: "*", element: <Adh gotoAuth={gotoAuth} annee={anneeSel} tribus={tribus} reloadTribus={getTribus} /> },
        { path: "/", element: <Adh gotoAuth={gotoAuth} annee={anneeSel} tribus={tribus} reloadTribus={getTribus} /> },
        // { path: "/adherents", element: <Adherent adherentsLight={adherentsLight} setAdherentsLight={setAdherentsLight} reloadData={reloadData} gotoAuth={gotoAuth} /> },
        { path: "/adhere/:code/:mail/:success", element: <Adhere /> },
        { path: "/adhesion", element: <AdhesionByType type='first' gotoAuth={gotoAuth} /> },
        { path: "/adhesionmanuelle", element: <AdhesionManuelle gotoAuth={gotoAuth} /> },

        { path: "/gerecotisation", element: <CotisationGere authOK={authOK} /> },
        { path: "/gerechoix", element: <CotisationChoix authOK={authOK} getCotisation={getCotisation} /> },
        { path: "/sepa", element: <PrelevementSepaForm /> },

        { path: "/export", element: <Export gotoAuth={gotoAuth} annee={anneeSel} /> },
        { path: "/tribu", element: <TribuRappro gotoAuth={gotoAuth} annee={anneeSel} /> },
        { path: "/mail", element: <Mail gotoAuth={gotoAuth} annee={anneeSel} /> },
        { path: "/relance", element: <Relance gotoAuth={gotoAuth} /> },

        { path: "/managereseau", element: <ManageDropdown type='reseau' /> },

        { path: "/facturemanuelle", element: <GenerePdfManuel /> },
        { path: "/prelevement", element: <Prelevement /> },
        { path: "/tribucrm", element: <Tribu gotoAuth={gotoAuth} annee={anneeSel} tribus={tribus} reloadTribus={getTribus} /> },
    ]);
    return routes;
};


const Footer = ({ version }) => {
    return (
        <footer className="mt-4 text-center blockquote-footer">
            <p>{version}<br />
                © {moment().year()} CRM K-Lix
            </p>
        </footer>
    );
};

const AppWrapper = ({ version, smallurl, url }) => {

    const [date, setDate] = useState(new Date());
    const [isAdmin, setIsAdmin] = useState(false);
    const [authentOk, setAuthentOk] = useState(true);
    const [anneeSel, setAnneeSel] = useState(2026);
    const [displayButtons, setDisplayButtons] = useState(false);

    const handleDeconnexion = () => {
        localStorage.removeItem('code');
        window.location.reload();
    }

    return (
        <>
            {/* <Header /> */}

            <Router>
                {!authentOk && <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container">
                        <Link to="/auth" className="navbar-brand" onClick={() => setDate(new Date())}>
                            <img src={logo} alt="Logo" className="logo" style={{ height: '80px' }} /> {/* Ajoutez cette balise img */}
                        </Link>
                        <Link to="/auth" className="navbar-brand">Authentification</Link>
                    </div>
                </nav>
                }
                {isAdmin && authentOk && <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container">
                        <Link to="/" className="navbar-brand" onClick={() => setDate(new Date())}>
                            <img src={logo} alt="Logo" className="logo" style={{ height: '80px' }} /> {/* Ajoutez cette balise img */}
                        </Link>

                        <Link to="/" className="navbar-brand">Synthèse</Link>
                        {/* <Link to="/adherents" className="navbar-brand">Adhérents</Link> */}

                        {/* <Link to="/export" className="navbar-brand">Export</Link> */}

                        {/* <DropdownButton variant="outline-secondary" as={ButtonGroup} title="Adhésion" id="bg-nested-dropdown">
                            <Dropdown.Item eventKey="3"><Link className="dropdown-item" to="/adhesion">Adhésion</Link></Dropdown.Item>
                            <Dropdown.Item eventKey="4"><Link className="dropdown-item" to="/adhesionmanuelle">Adhésion manuelle</Link></Dropdown.Item>
                        </DropdownButton> */}

                        <DropdownButton variant="outline-secondary" as={ButtonGroup} title="Administration" id="bg-nested-dropdown">
                            <Dropdown.Item eventKey="4"><Link className="dropdown-item" to="/gerecotisation">Gestion des cotisations</Link></Dropdown.Item>
                            <Dropdown.Item eventKey="4"><Link className="dropdown-item" to="/managereseau">Gestion des réseaux</Link></Dropdown.Item>

                            <Dropdown.Item eventKey="5"><Link className="dropdown-item" to="/mail" >Mail</Link></Dropdown.Item>
                            <Dropdown.Item eventKey="6"><Link className="dropdown-item" to="/relance" >Relance</Link></Dropdown.Item>
                            <Dropdown.Item eventKey="8"><Link className="dropdown-item" to="/facturemanuelle" >Facture Manuelle</Link></Dropdown.Item>
                            <Dropdown.Item eventKey="9"><Link className="dropdown-item" to="/prelevement" >Prelevement</Link></Dropdown.Item>
                            <Dropdown.Item eventKey="10"><Link className="dropdown-item" to="/tribu" >Tribu rapprochement</Link></Dropdown.Item>
                            <Dropdown.Item eventKey="11"><Link className="dropdown-item" to="/tribucrm" >Tribu</Link></Dropdown.Item>

                            {/* <Dropdown.Item eventKey="7"><Link className="dropdown-item" onClick={handleDeconnexion} >Déconnexion</Link></Dropdown.Item> */}

                        </DropdownButton>


                        <div className="navbar-brand" style={{ display: 'flex', alignItems: 'center' }}>

                            <div
                                onMouseEnter={() => setDisplayButtons(true)}
                                onMouseLeave={() => setDisplayButtons(false)}>
                                <div style={{ flexDirection: 'row', marginLeft: '10px' }}>
                                    <Button style={{ display: displayButtons ? '' : 'none' }} variant="outline-secondary"
                                        onClick={() => setAnneeSel(anneeSel - 1)}>
                                        <FaChevronLeft />
                                    </Button>
                                    {anneeSel}
                                    <Button style={{ display: displayButtons ? '' : 'none' }} variant="outline-secondary"
                                        onClick={() => setAnneeSel(anneeSel + 1)}>
                                        <FaChevronRight />
                                    </Button>
                                    <div style={{ width: '85px', display: displayButtons ? 'none' : '' }}></div>
                                </div>
                            </div>
                        </div>
                        <Link className="navbar-brand" onClick={handleDeconnexion} >Déconnexion</Link>
                    </div>
                </nav>
                }
                <div className='container mt-4'>
                    <App setIsAdmin={setIsAdmin} setAuthentOk={setAuthentOk} anneeSel={anneeSel} setAnneeSel={setAnneeSel} smallurl={smallurl} url={url} />
                </div>
                <Footer version={version} />
            </Router>
        </>
    );
};
export default AppWrapper;